import "./Preloader.css";

const Preloader = () => (
  <div className="pl" aria-label="Loading" role="status">

    {/* Ambient radial glow behind everything */}
    <div className="pl-ambient" aria-hidden="true" />

    {/* Spinning gradient arc + centred logo */}
    <div className="pl-stage" aria-hidden="true">
      <svg className="pl-svg" viewBox="0 0 220 220" fill="none">
        <defs>
          <linearGradient id="plGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%"   stopColor="#FF6B35" />
            <stop offset="60%"  stopColor="#F7931E" />
            <stop offset="100%" stopColor="#667EEA" />
          </linearGradient>
        </defs>
        {/* faint track */}
        <circle cx="110" cy="110" r="96"
          stroke="rgba(255,107,53,0.12)" strokeWidth="1.5" />
        {/* animated arc */}
        <circle cx="110" cy="110" r="96"
          stroke="url(#plGrad)" strokeWidth="2.5"
          strokeLinecap="round"
          strokeDasharray="603"
          className="pl-arc" />
        {/* inner decorative ring */}
        <circle cx="110" cy="110" r="80"
          className="pl-ring-inner" strokeWidth="1" fill="none" />
      </svg>

      {/* Logo sits exactly in the centre of the SVG */}
      <div className="pl-logo-wrap">
        <span className="pl-logo">NF<em>.</em></span>
      </div>
    </div>

    {/* Text below the circle */}
    <div className="pl-meta" aria-hidden="true">
      <p className="pl-name">Navodya Fernando</p>
      <p className="pl-role">Software Engineer · Dubai, UAE</p>
    </div>

    {/* Bouncing dots */}
    <div className="pl-dots" aria-hidden="true">
      <span /><span /><span />
    </div>
  </div>
);

export default Preloader;
